import SkapaStatus, { type StatusProps } from "@ingka/status";

export type { StatusProps } from "@ingka/status";

export const Status = (props: StatusProps) => {
  return <SkapaStatus prefix="saleslead__" {...props} />;
};
